import type {
  AgentGetAgentTradePerformanceChartParams,
  AgentGetPortfolioChartInput,
  AgentGetWalletPortfolioChartInput,
} from '../api'
import {
  getAgentPortfolio,
  getAgentPortfolioChart,
  agentGetTradePerformance,
  agentGetAgentTradePerformanceChart,
  getAgentWalletPortfolioChart,
} from './agent-portfolio.service'
import { EAgentPortfolioQueryKey } from './agent-portfolio.types'
import { Cookie } from '@repo/tools'

export const agentPortfolioOptions = () => ({
  queryKey: [EAgentPortfolioQueryKey.AGENT_PORTFOLIO],
  queryFn: getAgentPortfolio,
  staleTime: 2,
  enabled: !!Cookie.get('access_token'),
})

export const agentPortfolioChartOptions = (
  params: AgentGetPortfolioChartInput,
) => ({
  queryKey: [EAgentPortfolioQueryKey.AGENT_PORTFOLIO_TIME_SERIES, params],
  queryFn: () => getAgentPortfolioChart(params),
})

export const agentTradePerformanceOptions = () => ({
  queryKey: [EAgentPortfolioQueryKey.AGENT_PERFORMANCE],
  queryFn: () => agentGetTradePerformance(),
})

export const agentTradePerformanceChartOptions = (
  params: AgentGetAgentTradePerformanceChartParams,
) => ({
  queryKey: [EAgentPortfolioQueryKey.AGENT_PERFORMANCE_CHART, params],
  queryFn: () => agentGetAgentTradePerformanceChart(params),
})
export const agentWalletPortfolioChartOptions = (
  params: AgentGetWalletPortfolioChartInput,
) => ({
  queryKey: [EAgentPortfolioQueryKey.AGENT_WALLET_PORTFOLIO_CHART, params],
  queryFn: () => getAgentWalletPortfolioChart(params),
})
